import { AppBar, Box, Button, Stack, Toolbar, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

import background from "../res/block_background.jpg";
import boss from "../res/422.png";
import dofus from "../res/dofus.png";
import patreon from "../res/patreon.png";
import twitter from "../res/twitter.png";

export const Layout = () => {
  return (
    <>
      <AppBar position="fixed" sx={{ backgroundImage: `url(${background})` }}>
        <Toolbar variant="dense">
          <Stack direction="row" sx={{ flexGrow: 1 }}>
            <Button
              color="inherit"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
                whiteSpace: "nowrap",
              }}
              href="/"
            >
              <Box component="img" src={boss} width="32px" />
              <Typography>Les Boss</Typography>
            </Button>
            <Button
              color="inherit"
              disabled
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
                color: "lightgray",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              <Box component="img" src={dofus} width="32px" />
              <Typography>Les dofus (soon)</Typography>
            </Button>
          </Stack>
          <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
            <a
              href="https://www.patreon.com/Hankiou"
              target="_blank"
              rel="noreferrer"
            >
              <Box component="img" src={patreon} width="26px" />
            </a>
            <a
              href="https://www.twitter.com/hankiou"
              target="_blank"
              rel="noreferrer"
            >
              <Box component="img" src={twitter} width="26px" />
            </a>
          </Stack>
        </Toolbar>
      </AppBar>
      <Outlet />
    </>
  );
};
